var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiRsCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_01_align_center",
    "data-name": "01 align center"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,2H18V0H16V2H8V0H6V2H3A3,3,0,0,0,0,5V24H24V5A3,3,0,0,0,21,2ZM2,5A1,1,0,0,1,3,4H21a1,1,0,0,1,1,1V8H2ZM2,22V10H22V22Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 13,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 13,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 13,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 17,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 17,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 17,
    width: 2,
    height: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRsCalendar);
export default __webpack_public_path__ + "static/media/fi-rs-calendar.f36987ca5488186729d73eab78d546e8.svg";
export { ForwardRef as ReactComponent };